module.exports = __webpack_public_path__ + "static/media/Cerdo asado con mostaza.c9303ddb.webp";